<template>
  <div class="audit-container">
    <!-- 数据审查说明 -->
    <el-card class="audit-intro">
      <div slot="header">
        <span>数据审查流程</span>
      </div>
      <div class="flow-steps">
        <el-steps :active="5" finish-status="success" align-center>
          <el-step title="数据采集">
            <template #description>
              <div>爬虫抓取数据</div>
              <div>存储到数据库</div>
            </template>
          </el-step>
          <el-step title="自动检查">
            <template #description>
              <div>完整性检查</div>
              <div>一致性检查</div>
              <div>重复性检查</div>
            </template>
          </el-step>
          <el-step title="问题标记">
            <template #description>
              <div>标记异常数据</div>
              <div>生成问题报告</div>
            </template>
          </el-step>
          <el-step title="人工审核">
            <template #description>
              <div>审核异常数据</div>
              <div>修正错误数据</div>
            </template>
          </el-step>
          <el-step title="状态更新">
            <template slot="description">
              <div>更新finish状态</div>
              <div>记录处理结果</div>
            </template>
          </el-step>
        </el-steps>
      </div>
    </el-card>

    <!-- 数据质量检查 -->
    <el-card class="audit-section">
      <div slot="header">
        <span>数据质量检查</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="handleCheck">开始检查</el-button>
      </div>
      
      <el-table :data="auditResults" v-loading="loading">
        <el-table-column prop="type" label="检查类型" width="150">
          <template slot-scope="scope">
            <el-tag :type="getTagType(scope.row.type)">{{ scope.row.type }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="问题描述" min-width="200"></el-table-column>
        <el-table-column prop="count" label="影响数据量" width="120"></el-table-column>
        <el-table-column prop="suggestion" label="处理建议" min-width="200"></el-table-column>
        <el-table-column label="操作" width="120">
          <template v-slot="scope">
            <el-button v-if="scope.$index===2" type="text" @click="handleFix(scope.row)">修复</el-button>
            <el-button v-if="scope.$index!==2" type="text" @click="handleDetail(scope.$index)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 数据审查规则 -->
    <el-card class="audit-rules">
      <div slot="header">
        <span>数据审查规则说明</span>
      </div>
      <el-collapse v-model="activeRules">
        <el-collapse-item title="1. 数据完整性检查" name="1">
          <div>检查必填字段：link, title, content, source, date</div>
          <div>检查字段是否为空或格式是否正确</div>
        </el-collapse-item>
        <el-collapse-item title="2. 数据一致性检查" name="2">
          <div>检查 company 是否符合标准命名</div>
          <div>检查 tag 是否在预定义范围内</div>
          <div>检查 date 是否在合理范围内</div>
        </el-collapse-item>
        <el-collapse-item title="3. 数据重复性检查" name="3">
          <div>检查 link 是否存在重复</div>
          <div>检查 title + content 是否存在相似内容</div>
        </el-collapse-item>
        <el-collapse-item title="4. 数据有效性检查" name="4">
          <div>检查 link 是否可访问</div>
          <div>检查 content 是否包含有效内容</div>
          <div>检查 source 是否为可信来源</div>
        </el-collapse-item>
      </el-collapse>
    </el-card>
    <el-drawer
        title="异常数据"
        :visible.sync="displayTable"
        direction="rtl"
        size="50%">
      <div style="display: flex; justify-content: center">
        <el-button type="danger" @click="handleDeleteAll">删除已选</el-button>
        <el-button type="primary" @click="handleSelectChangeState">反选</el-button>
      </div>
      <el-table
          :data="tableData"
          border
          @selection-change="handleSelectionChange"
          @cell-click="handleClick"
          ref="multipleTable"
          style="width: 100%">
        <el-table-column type="selection">
        </el-table-column>
        <el-table-column
            prop="date"
            label="日期"
            width="120"
        >
          <template v-slot="scope">
            {{scope.row.date | formatDate}}
          </template>
        </el-table-column>
        <el-table-column
            prop="title"
            label="标题"
            show-overflow-tooltip>
          <template v-slot="scope">
            <el-link type="primary" :href="scope.row.link">{{ scope.row.title }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
            prop="source"
            label="来源"
            width="120">
        </el-table-column>
        <el-table-column
            prop="tag"
            label="标签"
            width="100">
          <template v-slot="scope">
            <el-tag :type="getTagTypeShow(scope.row.tag)">{{ scope.row.tag }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop="finish"
            label="完成状态"
            width="100">
          <template v-slot="scope">
            <el-tag :type="scope.row.finish ? 'success' : 'error'">
              {{ scope.row.finish ? '已完成' : '未完成' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
        label="操作">
          <template v-slot="scope">
            <el-button type="danger" @click.capture.self.prevent="handleDelete(scope.row)" icon="el-icon-delete"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>

  </div>
</template>

<script>
import axios from "axios";
import {mapState} from "vuex";
import qs from 'qs'
export default {
  name: 'DataAudit',
  data() {
    return {
      multipleSelection:[],
      loading: false,
      activeRules: ['1'],
      auditResults: [
        {
          type: '数据不一致',
          description: 'tag 字段存在非标准值',
          count: 28,
          suggestion: '统一标签分类标准'
        },
        {
          type: '链接异常',
          description: '发现异常的新闻链接',
          count: 12,
          suggestion: '清理或标记无效链接'
        },
        {
          type: '数据缺失',
          description: 'company 字段为"待定"的数据需要处理',
          count: 156,
          suggestion: '根据 title 和 content 内容提取公司名称'
        },
        {
          type: '测试数据',
          description: '测试数据待清除',
          count: 156,
          suggestion: '用于测试功能的记录，不具备实际含义'
        },
      ],
      newsData1:[],
      newsData2:[],
      newsData3:[],
      tableData:[],
      displayTable:false
    }
  },
  computed:{
    ...mapState(['baseUrl'])
  },
  filters:{
    formatDate([year, month, day]){
      // 确保月份和日期是两位数
      const formattedMonth = month.toString().padStart(2, '0');
      const formattedDay = day.toString().padStart(2, '0');

      // 使用模板字符串构建日期
      return `${year}-${formattedMonth}-${formattedDay}`;
    },
  },
  methods: {
    handleDeleteAll(){
      console.log('delete choice');
      let dat = [...this.multipleSelection.map(item => item.link)]
      let config={
        params:{link:dat},
        paramsSerializer: params => {
          return qs.stringify(params, { indices: false })
        }
      }
      axios.delete(`${this.baseUrl}/news/batch`,config).then(res => {
        if (res.data.success){
          this.$message.success("删除成功")
          console.log('tableData', {...this.tableData})
          console.log('multipleSelection', {...this.multipleSelection})
          this.tableData=this.tableData.filter(news=>
            !this.multipleSelection.some(item=>{
              console.log('news.link:',news.link,'item.link',item.link)
              return news.link===item.link
            })
          )
          console.log('tableData', {...this.tableData})
          console.log('multipleSelection', {...this.multipleSelection})
        }else {
          this.$message.error(res.data.msg);
        }
      }).catch(err => {
        console.log(err)
        this.$message.error("删除失败,系统错误")
      }).finally(()=>{
        this.handleCheck();
      })
    },
    handleSelectChangeState(){
      this.toggleSelection(this.tableData)
    },
    handleDelete(row){
      axios.delete(`${this.baseUrl}/news`,{params:{link:row.link}}).then(res => {
        if (res.data.success){
          this.$message.success("删除成功")
        }else {
          this.$message.error(res.data.msg);
        }
        this.tableData=this.tableData.filter(tableItem =>
            !(tableItem.link===row.link)
        );
      }).catch(err => {
        console.log(err)
        this.$message.error("删除失败")
      }).finally(()=>{
        this.handleCheck()
      })
    },
    handleClick(row){
      console.log('click row')
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    getTagTypeShow(tag) {
      switch(tag) {
        case '正面新闻':
          return 'success'
        case '负面新闻':
          return 'danger'
        default:
          return 'info'
      }
    },
    getTagType(type) {
      const types = {
        '数据缺失': 'warning',
        '数据不一致': 'warning',
        '链接异常': 'danger'
      }
      return types[type] || ''
    },
    handleCheck() {
      this.loading = true
      Promise.all([axios.get(`${this.baseUrl}/news/excludeTag`),
        axios.get(`${this.baseUrl}/news/excludeLink`),
        axios.get(`${this.baseUrl}/news/query/light`,{params:{company:"待定"}}),
        axios.get(`${this.baseUrl}/news/testData`),
      ]).then((response) => {
        this.$message.success('数据检查完成')
        this.auditResults[0]['count'] = response[0].data.total;
        this.newsData1 = response[0].data.data;
        this.auditResults[1]['count'] = response[1].data.total;
        this.newsData2 = response[1].data.data;
        this.auditResults[2]['count'] = response[2].data.total;
        this.auditResults[3]['count'] = response[3].data.total;
        this.newsData3 = response[3].data.data;
      }).catch(()=>{
        this.$message.error('数据检查失败')
      }).finally(()=>{
        this.loading = false
      })
    },
    handleFix(row) {
      this.$message({
        type: 'success',
        message: `正在联系管理员加快处理`
      })
    },
    handleDetail(index) {
      if (index===0){
        this.tableData=this.newsData1;
      }else if(index===1){
        this.tableData=this.newsData2;
      }else if(index===3){
        this.tableData=this.newsData3;
      }
      this.displayTable=true
    }
  },
  mounted() {
    this.handleCheck()
  }
}
</script>

<style scoped>
.audit-container {
  padding: 20px;
}

.audit-intro, .audit-section, .audit-rules {
  margin-bottom: 20px;
}

.flow-steps {
  margin: 40px 0;
  padding: 0 40px;
}

.el-collapse-item {
  margin: 10px 0;
}

.el-collapse-item >>> .el-collapse-item__content {
  padding: 10px 20px;
  color: #666;
  line-height: 1.8;
}

.el-steps >>> .el-step__description {
  font-size: 12px;
  line-height: 1.5;
}
</style> 